import React, { useContext } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import { ReactComponent as ArrowupIcon } from "../../icons/arrowupicon.svg";
import { ReactComponent as DropdownIcon } from "../../icons/dropdownn.svg";
import * as Icons from "../../icons";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import NavItem from "./NavItem";
import { hexToRgb } from "utils/colors.utils";

function Icon({ icon, ...props }) {
  const Icon = Icons[icon];
  return Icon ? <Icon {...props} /> : <div className="px-6">I</div>;
}

const MENU = ({ route, currentMainMenuName }) => {
  const [subRoute, setSubRoute] = React.useState(false);
  const [subRouteIndex, setSubRouteIndex] = React.useState(0);
  const { collapsed } = useContext(AuthContext);
  const { t } = useTranslation();
  const { theme } = useTheme();
  const showSubRoutes = () => {
    setSubRoute(!subRoute);
  };
  const { globalConfig } = useContext(AuthContext);


  if (route.name === "AuthConfig") {
    const enableAuthConfig = globalConfig?.find(
      (config) => config.key === "enableAuthConfig"
    );
    if (enableAuthConfig?.value === "false") {
      return null;
    }
  }



  return (
    <div
      className={`flex flex-col ${subRoute ? `${theme.sideMenuColor}` : null}`}
    >
      <div
        className={`flex-row cursor-pointer `}
        style={{ color: theme.menuTextColor }}
        onClick={route.subRoutes && showSubRoutes}
      >
        <NavItem
          onClick={() => {
            setSubRouteIndex(0);
          }}
          action={route?.action}
          url={route?.url}
          to={
            route?.subRoutes && route?.subRoutes?.length > 0
              ? route.subRoutes[subRouteIndex].path
              : route.path
          }
          isSubRoute={route?.subRoutes}
          menuTextColor={theme.menuTextColor}
          menuTextHoverColor={theme.menuTextColorOnHover}
          className="flex py-[10px]"
        >
          <Icon
            className="ml-[21px] mr-[15px] w-[14px] h-auto"
            icon={route.icon}
          />

          {!collapsed && (
            <>
              <h1 className="text-xs pt-0.5 text-wrap w-28 cursor-pointer">
                {t(`${route.name}`)}
              </h1>

              {route.subRoutes && subRoute ? (
                <div className="flex flex-row-reverse flex-grow self-center mx-5">
                  <ArrowupIcon className="w-[10px] h-[6px]" />
                </div>
              ) : route.subRoutes ? (
                <div className="flex flex-row-reverse flex-grow self-center mx-5">
                  <DropdownIcon className="w-[10px] h-[6px]" />
                </div>
              ) : null}
            </>
          )}
        </NavItem>
      </div>

      {route?.subRoutes &&
      subRoute &&
      route?.subRoutes?.length > 0 &&
      !collapsed
        ? route.subRoutes.map((subRoute, i) => {
            // route.path+subRoute.path
            return (
              <div key={`${subRoute.name}${i}`} 
                className={`py-1 ${
                  route.subRoutes.length - 1 === i ? "pb-3" : null
                }`} 
                style={{
                  backgroundColor: currentMainMenuName === route.name 
                    ? `rgba(${hexToRgb(theme?.menuTextColorOnHover)}, 0.05)`
                    : null,
                }}
              >
                <NavLink
                  onClick={() => setSubRouteIndex(i)}
                  to={subRoute.path}
                  key={`${subRoute.name}${i}`}
                  style={({ isActive }) =>
                    isActive
                      ? { color: theme.menuTextColorOnHover }
                      : { color: theme.menuTextColor }
                  }
                >
                  <h1
                    className={`text-xs ltr:ml-[52px] rtl:mr-[52px] cursor-pointer ${
                      subRoute ? "inline-block" : "hidden"
                    }`}
                  >
                    {t(`${subRoute.name}`)}
                  </h1>
                </NavLink>
                <Routes>
                  <Route path={subRoute.path} exact={route.exact} />
                </Routes>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default MENU;
